/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media only screen and (min-width:1400px){.happ-max-width[_ngcontent-%COMP%]{width:70%;margin:auto}}@media only screen and (min-width:900px){.happ-max-width[_ngcontent-%COMP%]{width:85%;margin:auto}}@media only screen and (max-width:900px){.happ-max-width[_ngcontent-%COMP%]{width:100%;margin:auto}}"];
export { styles as styles };
